"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _hasInterface = _interopRequireDefault(require("../../../../hasInterface"));

var _StringUtil = _interopRequireDefault(require("../util/StringUtil"));

var _Double = _interopRequireDefault(require("../../../../java/lang/Double"));

var _CoordinateSequence = _interopRequireDefault(require("./CoordinateSequence"));

var _StringBuilder = _interopRequireDefault(require("../../../../java/lang/StringBuilder"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CoordinateSequences =
/*#__PURE__*/
function () {
  function CoordinateSequences() {
    _classCallCheck(this, CoordinateSequences);

    CoordinateSequences.constructor_.apply(this, arguments);
  }

  _createClass(CoordinateSequences, [{
    key: "getClass",
    value: function getClass() {
      return CoordinateSequences;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "copyCoord",
    value: function copyCoord(src, srcPos, dest, destPos) {
      var minDim = Math.min(src.getDimension(), dest.getDimension());

      for (var dim = 0; dim < minDim; dim++) {
        dest.setOrdinate(destPos, dim, src.getOrdinate(srcPos, dim));
      }
    }
  }, {
    key: "isRing",
    value: function isRing(seq) {
      var n = seq.size();
      if (n === 0) return true;
      if (n <= 3) return false;
      return seq.getOrdinate(0, _CoordinateSequence.default.X) === seq.getOrdinate(n - 1, _CoordinateSequence.default.X) && seq.getOrdinate(0, _CoordinateSequence.default.Y) === seq.getOrdinate(n - 1, _CoordinateSequence.default.Y);
    }
  }, {
    key: "isEqual",
    value: function isEqual(cs1, cs2) {
      var cs1Size = cs1.size();
      var cs2Size = cs2.size();
      if (cs1Size !== cs2Size) return false;
      var dim = Math.min(cs1.getDimension(), cs2.getDimension());

      for (var i = 0; i < cs1Size; i++) {
        for (var d = 0; d < dim; d++) {
          var v1 = cs1.getOrdinate(i, d);
          var v2 = cs2.getOrdinate(i, d);
          if (cs1.getOrdinate(i, d) === cs2.getOrdinate(i, d)) continue;
          if (_Double.default.isNaN(v1) && _Double.default.isNaN(v2)) continue;
          return false;
        }
      }

      return true;
    }
  }, {
    key: "extend",
    value: function extend(fact, seq, size) {
      var newseq = fact.create(size, seq.getDimension());
      var n = seq.size();
      CoordinateSequences.copy(seq, 0, newseq, 0, n);

      if (n > 0) {
        for (var i = n; i < size; i++) {
          CoordinateSequences.copy(seq, n - 1, newseq, i, 1);
        }
      }

      return newseq;
    }
  }, {
    key: "reverse",
    value: function reverse(seq) {
      var last = seq.size() - 1;
      var mid = Math.trunc(last / 2);

      for (var i = 0; i <= mid; i++) {
        CoordinateSequences.swap(seq, i, last - i);
      }
    }
  }, {
    key: "swap",
    value: function swap(seq, i, j) {
      if (i === j) return null;

      for (var dim = 0; dim < seq.getDimension(); dim++) {
        var tmp = seq.getOrdinate(i, dim);
        seq.setOrdinate(i, dim, seq.getOrdinate(j, dim));
        seq.setOrdinate(j, dim, tmp);
      }
    }
  }, {
    key: "copy",
    value: function copy(src, srcPos, dest, destPos, length) {
      for (var i = 0; i < length; i++) {
        CoordinateSequences.copyCoord(src, srcPos + i, dest, destPos + i);
      }
    }
  }, {
    key: "toString",
    value: function toString() {
      if (arguments.length === 1 && (0, _hasInterface.default)(arguments[0], _CoordinateSequence.default)) {
        var cs = arguments[0];
        var size = cs.size();
        if (size === 0) return "()";
        var dim = cs.getDimension();
        var builder = new _StringBuilder.default();
        builder.append('(');

        for (var i = 0; i < size; i++) {
          if (i > 0) builder.append(" ");

          for (var d = 0; d < dim; d++) {
            if (d > 0) builder.append(",");
            builder.append(_StringUtil.default.toString(cs.getOrdinate(i, d)));
          }
        }

        builder.append(')');
        return builder.toString();
      }
    }
  }, {
    key: "ensureValidRing",
    value: function ensureValidRing(fact, seq) {
      var n = seq.size();
      if (n === 0) return seq;
      if (n <= 3) return CoordinateSequences.createClosedRing(fact, seq, 4);
      var isClosed = seq.getOrdinate(0, _CoordinateSequence.default.X) === seq.getOrdinate(n - 1, _CoordinateSequence.default.X) && seq.getOrdinate(0, _CoordinateSequence.default.Y) === seq.getOrdinate(n - 1, _CoordinateSequence.default.Y);
      if (isClosed) return seq;
      return CoordinateSequences.createClosedRing(fact, seq, n + 1);
    }
  }, {
    key: "createClosedRing",
    value: function createClosedRing(fact, seq, size) {
      var newseq = fact.create(size, seq.getDimension());
      var n = seq.size();
      CoordinateSequences.copy(seq, 0, newseq, 0, n);

      for (var i = n; i < size; i++) {
        CoordinateSequences.copy(seq, 0, newseq, i, 1);
      }

      return newseq;
    }
  }]);

  return CoordinateSequences;
}();

exports.default = CoordinateSequences;

CoordinateSequences.constructor_ = function () {};